export default __webpack_public_path__ + "static/media/NoPost.fa3e438d.svg";